import React, { useState, useEffect } from "react";
import { Formik, Field, Form } from "formik";
import * as Yup from "yup";
import {
    InputGroup,
    FieldWrappers,
    Label,
    SubmitBtn,
    SideCancelBtn,
    Wrapper,
    ScrollableContent,
    ActionSection,
    ModalHeader,
} from "../../Styles/InputStyles";
import { MdClose, MdEdit } from "react-icons/md";
import tw from "tailwind-styled-components";
import { beneficiary_type_roles } from "../../../Config";
import SelectOptionModal from "../../SelectOptionModal";
import VerifyBankAccount from "../../Common/VerfiyBankAccount";

const CreateStaffWallet = ({
    createWalletMutate,
    createWalletLoading,
    handleClose,
    staffListOptions,
    walletBalance
}) => {
    const initialValues = {
        staffId: "",
        amount: "",
        maxTransactionLimit: "",
        dailyLimit: "",
    };

    const [height, setHeight] = useState(window.innerHeight);
    const [isAssignModalOpen, setIsAssignModalOpen] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            setHeight(window.innerHeight);
        };

        window.addEventListener("resize", handleResize);
        handleResize();

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const beneficiaryRoleOptions = beneficiary_type_roles.map((role) => ({
        label: role.label,
        value: role.value,
    }));

    // Yup Validation Schema
    const validationSchema = Yup.object({
        staffId: Yup.number()
            .required("Staff member is required")
            .typeError("Staff member is required"),

        amount: Yup.number()
            .required("Initial amount is required")
            .typeError("Enter a valid amount")
            .min(0, "Amount cannot be negative")
            .max(
                Number(walletBalance || 0),
                `Amount cannot be greater than your wallet balance of ₹${Number(
                    walletBalance || 0
                ).toLocaleString("en-IN")}`
            ),

        maxTransactionLimit: Yup.number()
            .required("Maximum transaction limit is required")
            .typeError("Enter a valid amount")
            .min(1, "Transaction limit must be greater than 0"),

        // dailyLimit: Yup.number()
        //     .required("Daily limit is required")
        //     .typeError("Enter a valid amount")
        //     .min(1, "Daily limit must be greater than 0"),
    });

    const handleSubmit = async (values, { resetForm, setSubmitting }) => {
        const payload = {
            amount: Number(values.amount),
            maxTransactionLimit: Number(values.maxTransactionLimit),
            //dailyLimit: Number(values.dailyLimit),
            dailyLimit: 0,
            //accountName: values.accountName,
            staffId: values.staffId,
        };

        createWalletMutate(payload);
    };

    return (
        <Container
            style={{
                height: `${height}px`,
                overflow: "auto",
                WebkitOverflowScrolling: "touch",
            }}
        >
            <ModalHeader>
                <h1 className="text-white text-lg font-medium">Create Staff Wallet</h1>
                <button onClick={handleClose}>
                    <MdClose color="white" size={24} />
                </button>
            </ModalHeader>
            <div className="custom-scrollbar px-6 h-full flex flex-col justify-between">
                <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                    validateOnChange={true}
                    validateOnBlur={true}
                >
                    {({ errors, touched, isSubmitting, values, setFieldValue }) => {
                        const getCurrentRoleLabel = () => {
                            const selectedStaff = staffListOptions.find(
                                (role) => role.value === values?.staffId
                            );
                            return selectedStaff ? selectedStaff.label : "Select staff";
                        };

                        const handleStaffSelect = (selectedValue) => {
                            setFieldValue("staffId", selectedValue);
                        };

                        return (
                            <Form>
                                <ScrollableContent className="max-h-[calc(100vh-140px)]">
                                    <Wrapper>
                                        {/* Beneficiary Type Selection - Similar to Staff Role */}
                                        <InputGroup>
                                            <Label htmlFor="staffId">Select Staff *</Label>
                                            <FieldWrappers onClick={() => setIsAssignModalOpen(true)}>
                                                <Field
                                                    type="text"
                                                    name="staffId"
                                                    id="staffId"
                                                    autoComplete="off"
                                                    readOnly
                                                    value={getCurrentRoleLabel()}
                                                    className="w-full border-none outline-none bg-transparent cursor-pointer"
                                                    placeholder="Select beneficiary type"
                                                />
                                                <MdEdit className="w-4 h-4 text-gray-400 hover:text-gray-600 transition-colors duration-200 flex-shrink-0 mr-2" />
                                            </FieldWrappers>
                                            {errors.staffId && touched.staffId && (
                                                <ErrorText>{errors.staffId}</ErrorText>
                                            )}
                                        </InputGroup>


                                        <InputGroup>
                                            <Label htmlFor="mobileNo">Initial Wallet Balance *</Label>
                                            <FieldWrappers>
                                                <Field
                                                    type="tel"
                                                    name="amount"
                                                    id="amount"
                                                    autoComplete="off"
                                                    maxLength="10"
                                                    placeholder="Enter wallet balance"
                                                    className={errors.amount && touched.amount ? "border-red-500" : ""}
                                                />
                                            </FieldWrappers>
                                            {errors.amount && touched.amount && (
                                                <ErrorText>{errors.amount}</ErrorText>
                                            )}
                                            <div className="flex justify-between mt-1">
                                                <span className="text-xs text-gray-400">
                                                    Available wallet balance
                                                </span>

                                                <span className="text-xs font-medium text-gray-600">
                                                    ₹{Number(walletBalance || 0).toLocaleString("en-IN")}
                                                </span>
                                            </div>
                                        </InputGroup>


                                        <InputGroup>
                                            <Label htmlFor="mobileNo">Maximum Transaction Limit *</Label>
                                            <FieldWrappers>
                                                <Field
                                                    type="tel"
                                                    name="maxTransactionLimit"
                                                    id="maxTransactionLimit"
                                                    autoComplete="off"
                                                    maxLength="10"
                                                    placeholder="Enter maximum transaction limit"
                                                    className={errors.maxTransactionLimit && touched.maxTransactionLimit ? "border-red-500" : ""}
                                                />
                                            </FieldWrappers>
                                            {errors.maxTransactionLimit && touched.maxTransactionLimit && (
                                                <ErrorText>{errors.maxTransactionLimit}</ErrorText>
                                            )}
                                        </InputGroup>

                                        {/* <InputGroup>
                                            <Label htmlFor="mobileNo">Daily Payout Limit *</Label>
                                            <FieldWrappers>
                                                <Field
                                                    type="tel"
                                                    name="dailyLimit"
                                                    id="dailyLimit"
                                                    autoComplete="off"
                                                    maxLength="10"
                                                    placeholder="Enter Daily Limit number"
                                                    className={errors.dailyLimit && touched.dailyLimit ? "border-red-500" : ""}
                                                />
                                            </FieldWrappers>
                                            {errors.dailyLimit && touched.dailyLimit && (
                                                <ErrorText>{errors.dailyLimit}</ErrorText>
                                            )}
                                        </InputGroup> */}

                                    </Wrapper>
                                </ScrollableContent>

                                <ActionSection>
                                    <SideCancelBtn type="button" onClick={handleClose}>
                                        Cancel
                                    </SideCancelBtn>
                                    <SubmitBtn type="submit" disabled={isSubmitting || createWalletLoading}>
                                        {isSubmitting || createWalletLoading ? "Submitting..." : "Submit"}
                                    </SubmitBtn>
                                </ActionSection>

                                {/* Beneficiary Type Selection Modal */}
                                <SelectOptionModal
                                    isOpen={isAssignModalOpen}
                                    onClose={() => setIsAssignModalOpen(false)}
                                    title="Select Staff"
                                    options={staffListOptions}
                                    selectedValue={values.staffId}
                                    onSelect={handleStaffSelect}
                                    searchPlaceholder="Search staff..."
                                />
                            </Form>
                        );
                    }}
                </Formik>
            </div>
        </Container>
    );
};

const Container = tw.div`bg-white w-full h-full flex flex-col relative`;
const ErrorText = tw.div`text-red-500 text-sm ml-0.5 mt-1`;

export default CreateStaffWallet;